import React from 'react'
import { useState, useEffect } from "react";
import Toggle from "../../components/common/toggle";
import { LuDatabaseBackup } from "react-icons/lu";
import { TbSettingsSearch } from "react-icons/tb";

const BackUp = ({ data, setData }) => {
  const [enableBackup, setEnableBackup] = useState(true);
  const [backupFrequencyHours, setBackupFrequencyHours] = useState("");
  const [enableAuditLogs, setEnableAuditLogs] = useState(true);
  const [retainLogsDays, setRetainLogsDays] = useState("");

  useEffect(() => {
    if (data && data.backupSettings && data.backupSettings.backupFrequencyHours !== undefined) {
      setEnableBackup(data.backupSettings?.enableBackup ?? true);
      setBackupFrequencyHours(data.backupSettings?.backupFrequencyHours?.toString() || "");
      setEnableAuditLogs(data.audit?.enableAuditLogs ?? true);
      setRetainLogsDays(data.audit?.retainLogsDays?.toString() || "");
    }
  }, [data?.backupSettings?.enableBackup, data?.backupSettings?.backupFrequencyHours, data?.audit?.enableAuditLogs, data?.audit?.retainLogsDays]);

  useEffect(() => {
    if (setData && enableBackup !== undefined) {
      setData(prevData => ({
        ...prevData,
        backupSettings: {
          ...prevData.backupSettings,
          enableBackup,
          backupFrequencyHours: Number(backupFrequencyHours) || 0,
        },
        audit: {
          ...prevData.audit,
          enableAuditLogs,
          retainLogsDays: Number(retainLogsDays) || 0,
        }
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableBackup, backupFrequencyHours, enableAuditLogs, retainLogsDays]);
  return (
    <>
     <div className="auth">
        <div className="authentSetting">
          <h4>
            <LuDatabaseBackup /> Backup Settings
          </h4>
          <p>Control automatic backup configuration</p>

          <div className="body">
            <form action="post">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Enable Backup</label>
                  <p>Automatically backup system data</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setEnableBackup(newChecked)}
                  checked={enableBackup}
                />
              </div>

              <div
                className="text-inputs"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div style={{ width: "100%", marginTop: "20px" }}>
                  <label htmlFor="backupFrequency">
                    Backup Frequency (Hours){" "}
                  </label>
                  <br />
                    <input
                        type="number"
                        id="backupFrequency"
                        name="backupFrequencyHours"
                        placeholder="Type here..."
                        value={backupFrequencyHours}
                        onChange={(e) => setBackupFrequencyHours(e.target.value)}
                        style={{ width: "100%", marginTop: "10px" }}
                      />
                </div>
                <p>Backup every {backupFrequencyHours || 24} hours</p>
              </div>

              
            </form>
          </div>
        </div>

        <div className="authentSetting">
          <h4>
            <TbSettingsSearch /> Audit Settings
          </h4>
          <p>Manage system activity logs.
</p>
          <div className="body">
            <form action="post">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Enable Audit Logs </label>
                  <p>Track and log all system activities</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setEnableAuditLogs(newChecked)}
                  checked={enableAuditLogs}
                />
              </div>
              
              <div
                className="text-inputs"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div style={{ width: "100%", marginTop: "20px" }}>
                  <label htmlFor="logRetention">
                   Log Retention (Days){" "}
                  </label>
                  <br />
                    <input
                        type="number"
                        id="logRetention"
                        name="retainLogsDays"
                        placeholder="Type here..."
                        value={retainLogsDays}
                        onChange={(e) => setRetainLogsDays(e.target.value)}
                        style={{ width: "100%", marginTop: "10px" }}
                      />
                </div>
                <p>Logs older than {retainLogsDays || 90} days will be deleted</p>
              </div>

            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default BackUp